// Interactive Product Tour Component
// Guides new users through key features on first login

import React, { useState } from 'react';
import { Joyride, STATUS } from 'react-joyride';

const ProductTour = ({ run, onComplete }) => {
  const [stepIndex, setStepIndex] = useState(0);

  const steps = [
    {
      target: '[data-tour="dashboard-stats"]',
      content: (
        <div className="text-left">
          <h3 className="font-bold text-lg mb-2">📊 Your Dashboard</h3>
          <p className="text-sm text-slate-600">
            This is your command center. See total leads, conversion rates, and recent activity at a glance.
          </p>
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '[data-tour="leads-section"]',
      content: (
        <div className="text-left">
          <h3 className="font-bold text-lg mb-2">👥 Your Leads</h3>
          <p className="text-sm text-slate-600">
            Every potential client captured by your chatbot appears here. Click any lead to see their full case details, summary, and lead score.
          </p>
        </div>
      ),
      placement: 'top',
    },
    {
      target: '[data-tour="lead-score"]',
      content: (
        <div className="text-left">
          <h3 className="font-bold text-lg mb-2">⭐ Lead Scoring</h3>
          <p className="text-sm text-slate-600">
            <strong>A</strong> = High priority, detailed info provided<br/>
            <strong>B</strong> = Good detail provided<br/>
            <strong>C</strong> = Moderate detail<br/>
            <strong>D/F</strong> = Limited info, needs follow-up<br/><br/>
            Focus your time on A and B leads first!
          </p>
        </div>
      ),
      placement: 'left',
    },
    {
      target: '[data-tour="setup-checklist"]',
      content: (
        <div className="text-left">
          <h3 className="font-bold text-lg mb-2">✅ Setup Checklist</h3>
          <p className="text-sm text-slate-600">
            Complete these steps to get the most out of IntakePal. Each checkmark means you&apos;re closer to capturing more leads!
          </p>
        </div>
      ),
      placement: 'left',
    },
    {
      target: '[data-tour="nav-settings"]',
      content: (
        <div className="text-left">
          <h3 className="font-bold text-lg mb-2">⚙️ Settings & Setup</h3>
          <p className="text-sm text-slate-600">
            Customize your branding, notification preferences, and CMS integrations here. Make IntakePal match your firm&apos;s identity.
          </p>
        </div>
      ),
      placement: 'right',
    },
    {
      target: '[data-tour="help-button"]',
      content: (
        <div className="text-left">
          <h3 className="font-bold text-lg mb-2">❓ Need Help?</h3>
          <p className="text-sm text-slate-600">
            Click here anytime to access our Help Center, video tutorials, and support chat. No consultation needed — everything is self-service!
          </p>
        </div>
      ),
      placement: 'bottom',
    },
  ];

  const handleJoyrideCallback = (data) => {
    const { status, index } = data;
    
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Mark tour as completed in localStorage
      localStorage.setItem('intakepal_tour_completed', 'true');
      if (onComplete) onComplete();
    }
    
    setStepIndex(index);
  };

  const tourStyles = {
    options: {
      primaryColor: '#14b8a6', // teal-500
      backgroundColor: '#ffffff',
      textColor: '#334155',
      zIndex: 10000,
    },
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showProgress
      showSkipButton
      scrollToFirstStep
      spotlightClicks
      callback={handleJoyrideCallback}
      styles={tourStyles}
      locale={{
        back: 'Back',
        close: 'Close',
        last: 'Got it!',
        next: 'Next',
        skip: 'Skip tour',
      }}
    />
  );
};

export default ProductTour;
